import SetNewPassword from "./SetNewPassword";
export default SetNewPassword;
